module.exports = __webpack_public_path__ + "img/hoslogo18.44666b1e.png";